import SpinnerIcon from '@/components/icons/SpinnerIcon';
import { PaymentMethod } from '@/models/PaymentMethod';

interface StoreBillingPaymentDetailsPanelProps {
  isLoading: boolean;
  error?: unknown;
  paymentMethod?: PaymentMethod | null;
  paymentMethodLabel?: string | null;
  paymentMethodExpiry?: string | null;
}

const sectionClassName = 'rounded-2xl border border-slate-200 bg-white p-6 lg:p-8';

const sectionTitleClassName = 'text-lg font-semibold text-slate-900';

const StoreBillingPaymentDetailsPanel = ({
  isLoading,
  error,
  paymentMethod,
  paymentMethodLabel,
  paymentMethodExpiry,
}: StoreBillingPaymentDetailsPanelProps) => {
  const paymentMethodCard = paymentMethod?.card;

  return (
    <div className={`lg:col-span-2 ${sectionClassName}`}>
      <div className="mb-6 border-b border-slate-200 pb-4">
        <div className={sectionTitleClassName}>Payment details</div>
      </div>
      {isLoading ? (
        <div className="flex justify-center py-12">
          <SpinnerIcon />
        </div>
      ) : error ? (
        <div className="mt-4 rounded-md bg-red-50 p-4 text-sm text-red-700">
          Failed to load payment details.
        </div>
      ) : paymentMethodCard ? (
        <div className="mt-4 rounded-xl border border-slate-200 bg-white p-5">
          <div className="text-base font-semibold text-slate-900">{paymentMethodLabel}</div>
          <div className="mt-2 flex flex-wrap gap-2 text-xs">
            {paymentMethodCard.isDefault && (
              <span className="rounded-full bg-green-50 px-2.5 py-1 font-medium text-green-700">
                Default
              </span>
            )}
            <span
              className={`rounded-full px-2.5 py-1 font-medium ${
                paymentMethodCard.isActive
                  ? 'bg-blue-50 text-blue-700'
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              {paymentMethodCard.isActive ? 'Active' : 'Disabled'}
            </span>
          </div>
          <div className="mt-3 space-y-1 text-sm text-slate-600">
            {paymentMethodExpiry && <div>Expires {paymentMethodExpiry}</div>}
            <div>Provider: {paymentMethod.provider || 'Not available'}</div>
          </div>
        </div>
      ) : (
        <div className="mt-4 rounded-xl border border-dashed border-slate-200 bg-white p-5 text-sm text-slate-600">
          No payment details available yet.
        </div>
      )}
    </div>
  );
};

export default StoreBillingPaymentDetailsPanel;
